import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

/**
 * Componente para el modal de confirmación de eliminar cuenta
 */
@Component({
  standalone: false,
  selector: 'app-delete-acount',
  templateUrl: './delete-acount.component.html',
  styleUrls: ['./delete-acount.component.scss']
})
export class DeleteAcountComponent {

  /**
   * Crea una instancia para delete acount component.
   * @param dialogRef 
   */
  constructor(private dialogRef: MatDialogRef<DeleteAcountComponent>) { }


  /**
   * Cierra el modal
   */
  closeModal = (v) => {
    this.dialogRef.close(v);
  }
}
